const defaultDashboardState = {
  tiles: [],
};

const dashboardReducer = (state = defaultDashboardState, action) => {
  switch (action.type) {
    case 'SET_USER_DETAILS':
      return {
        tiles: action.tiles,
      };
    case 'CLEAR_USER_DETAILS':
      return defaultDashboardState;
    default:
      return state;
  }
};

export default dashboardReducer;
